export default "__VITE_ASSET__BUM1rQGH__"